export default __webpack_public_path__ + "static/media/model-registerstep-fin.4aabf9ef.png";